export default {
    props: {
        type: {
            type: String,
            default: "primary"
        },
        pulse: {
            type: Boolean,
            default: false
        }
    }
};
